function cloneDirectionsURL(directionsBTN) {
  const directionsURL = $('.header .standAloneDirections').attr('href');
  directionsBTN.attr('href', directionsURL);
  toggleTargetAttribute(directionsBTN);
}

function cleanContent(home) {
  const content = $(`.${home}`).find('.content');
  content.empty();
}

function moveWidgetsToMainContent(widgetContainer) {
  const $widgetContainer = $(`#${widgetContainer}`);
  const themeWidgetsContainer = $('.afterContent').find($widgetContainer);
  const sponsorWidget = themeWidgetsContainer.find('.sponsor-widget');
  $('#sponsorWidgetContainer').appendTo(sponsorWidget);
  const themeWidgets = themeWidgetsContainer.children();
  const content = $('.content');
  content.append(themeWidgets);
  $('.afterContent').empty();
}

function windowSize(viewport) {
  const width = $(window).width();
  return width < viewport;
}

const mobileBreakpoint = windowSize(800);

function removeLinkMobile(data, x, item) {
  const { URL, PurchaseURL } = data.items[x];
  const links = PurchaseURL || URL;
  if (mobileBreakpoint && links === null) {
    item.removeAttr('href');
    item.removeAttr('target');
  }
}

function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

function toggleTargetAttribute(cardLink) {
  const cardURL = cardLink.attr('href');
  const isLocalUrlCheck = isLocalUrl(cardURL);
  if (isLocalUrlCheck) {
    cardLink.removeAttr('target');
  }
}

function createCustomCards(widgetData, cards) {
  cards.each(function (x) {
    const card = $(this);
    const cardLink = card.find('a');
    removeLinkMobile(widgetData, x, card);
    if (cardLink.length === 0) {
      $(this).addClass('no-link');
    } else {
      toggleTargetAttribute(cardLink);
    }
  });
}

export {
  cloneDirectionsURL,
  cleanContent,
  createCustomCards,
  mobileBreakpoint,
  moveWidgetsToMainContent,
  removeLinkMobile,
  toggleTargetAttribute,
  windowSize,
};
